define('shared/initializer/form/adapters/mixins/OSCommon',[
        'shared/initializer/form/constants',
        'shared/util/state',
        'shared/util/fields/common',
        'shared/util/dispatchers/FormDataDispatcher',
        'shared/lib/RSVP',
        'shared/util/tracking/dailyLesson'
    ],
function (
    constants,
    state,
    fieldUtil,
    FormDataDispatcher,
    RSVP,
    dailyLessonUtil
) {
    'use strict';

    function fixRedirectUrlBeforeSubmit(){
        var $form = this.$form;

        return new RSVP.Promise(function(resolve){
            var $redirectURL = $form.find('input[name=redirectURL]');
            var redirectURLValue = $redirectURL.val();
            if (redirectURLValue){
                resolve(redirectURLValue);
                return;
            }

            var nextPageValue = $form.find('input[name=nextpage]').val();
            if (nextPageValue){
                $redirectURL.val(nextPageValue);
                resolve(nextPageValue);
                return;
            }

            var onSuccessUrl = $form.find('input[name=' + constants.FIELD.OnSuccessUrl + ']').val();
            if (onSuccessUrl){
                $redirectURL.val(onSuccessUrl);
                resolve(onSuccessUrl);
            }
            else{
                resolve('');
            }
        });
    }

    function retrieveEvents() {
        var me = this;
        return new RSVP.Promise(function(resolve){
            var events = [];
            events.push(constants.EVENT.MemberRegistration);

            if(dailyLessonUtil.dailyLessonSubscribed.apply(me)){
                events.push(constants.EVENT.EmailEnglish);
            }

            resolve(events);
        });
    }

    function Ctor() { }

    Ctor.prototype.doBeforeSubmit = function(){
        var basePromise = RSVP.resolve();
        var me = this;
        var $form = me.$form;
        return basePromise
            .then(function(){
                return fixRedirectUrlBeforeSubmit.call(me);
            })
            .then(function(redirectURLValue){
                var dispatcher = new FormDataDispatcher(me.$form);
                return dispatcher.dispatch({
                    items: {
                        'Pending event':
                        {
                            sources:
                                [{
                                    retrieve: function() {
                                        if (redirectURLValue == null) {
                                            return RSVP.resolve([]);
                                        }
                                        else {
                                            return retrieveEvents.call(me);
                                        }
                                    }
                                }],
                            targets:
                                [{
                                    type: 'state',
                                    key: constants.State.TrackingPendingEvents
                                }]
                        }
                    },
                    timeout: 1000 * 60 * 60
                });
            })
            .then(function(){
                if (me.items[constants.FIELD.PHONE_TYPE] == null) {
                    return RSVP.resolve();
                }
                var $phoneType = me.items[constants.FIELD.PHONE_TYPE].$el;

                var currentPhoneType = $phoneType.filter(':visible').filter(':checked').val();
                if(currentPhoneType === constants.PhoneType.Mobile){
                    fieldUtil.copyField(constants.FIELD.PHONE, 'telephone2', $form);
                    // TODO: why using prop rather attr here? is it because of browser bug?
                    $form.find('input[name="' + constants.FIELD.PHONE + '"]').prop('name', '--deleted--');
                }

                return RSVP.resolve();
            });
    };

    return Ctor;
});
